(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["designers-index"] && !Shopify.designMode) return;
  try {
    
  class DesignersIndex extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-designers-search]');
      if (!input) return;
      const items = Array.from(this.querySelectorAll('.designers-index__item'));
      const groups = Array.from(this.querySelectorAll('.designers-index__group'));
      const noResults = this.querySelector('[data-designers-noresults]');

      const filter = () => {
        const q = input.value.trim().toLowerCase();
        let anyVisible = false;
        items.forEach((item) => {
          const match = !q || (item.dataset.name || '').includes(q);
          item.hidden = !match;
          if (match) anyVisible = true;
        });
        groups.forEach((group) => {
          const hasVisible = group.querySelector('.designers-index__item:not([hidden])') !== null;
          group.hidden = !hasVisible;
        });
        if (noResults) noResults.hidden = anyVisible;
      };

      input.addEventListener('input', filter);
    }
  }

  if (!customElements.get('designers-index')) {
    customElements.define('designers-index', DesignersIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-metaobjects"] && !Shopify.designMode) return;
  try {
    
  class FaqSearch extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-faq-search]');
      if (!input) return;

      this.noResults = this.querySelector('[data-faq-noresults]');
      this.groups = this.buildGroups();

      input.addEventListener('input', () => this.filter(input.value));
    }

    // De FAQ-lijst is een platte reeks: categoriekop, gevolgd door de accordions
    // van die categorie. Die reeks vertalen we naar groepen {heading, items}.
    buildGroups() {
      const groups = [];
      let current = { heading: null, items: [] };

      Array.from(this.querySelectorAll('.faq__content > *')).forEach((node) => {
        if (node.classList.contains('faq__category')) {
          if (current.items.length > 0) groups.push(current);
          current = { heading: node, tocItem: this.tocItemFor(node), items: [] };
        } else {
          current.items.push(node);
        }
      });

      if (current.items.length > 0) groups.push(current);
      return groups;
    }

    tocItemFor(heading) {
      if (!heading.id) return null;
      return this.querySelector(`.faq__toc-item[href="#${CSS.escape(heading.id)}"]`);
    }

    filter(value) {
      const query = value.trim().toLowerCase();
      let anyVisible = false;

      this.groups.forEach((group) => {
        let visibleInGroup = 0;

        group.items.forEach((item) => {
          const match = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !match;
          if (match) visibleInGroup += 1;
        });

        // De inhoudsopgave blijft staan, anders hercentreert de flexbox en
        // verspringt de layout. Alleen de link naar een lege categorie gaat weg.
        // Let op: houd dit JS-blok ASCII-only. De bundler van de Shopify CLI
        // kapt compiled_assets/scripts.js af bij multibyte-tekens, waardoor het
        // custom element in de lokale preview niet meer registreert.
        if (group.heading) group.heading.hidden = visibleInGroup === 0;
        if (group.tocItem) group.tocItem.hidden = visibleInGroup === 0;
        if (visibleInGroup > 0) anyVisible = true;
      });

      if (this.noResults) this.noResults.hidden = anyVisible;
    }
  }

  if (!customElements.get('faq-search')) {
    customElements.define('faq-search', FaqSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
